import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './addName.css';

function AddName({ onAdd, onGenerateTickets }) {
  const [collectedNames, setCollectedNames] = useState([]);

  const handlePurchaseClick = async () => {
    const { value: numberOfEntries } = await Swal.fire({
      title: 'Quantas entradas deseja comprar?',
      input: 'number',
      inputLabel: 'Insira a quantidade desejada',
      inputAttributes: {
        min: 1,
        step: 1,
      },
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        popup: 'swal2-popup-custom',
        title: 'swal2-title-custom',
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom',
      },
      buttonsStyling: false,
    });

    if (numberOfEntries) {
      const count = parseInt(numberOfEntries, 10);

      const { isConfirmed, value: names } = await Swal.fire({
        title: 'Insira os nomes',
        html: Array(count)
          .fill('')
          .map(
            (_, index) =>
              `<input id="input-${index}" type="text" class="swal2-input" placeholder="Nome completo (igual ao RG) - ${index + 1}">`
          )
          .join(''),
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        customClass: {
          popup: 'swal2-popup-custom',
          title: 'swal2-title-custom',
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
        },
        buttonsStyling: false,
        preConfirm: () => {
          const inputs = Array(count)
            .fill('')
            .map((_, index) =>
              document.getElementById(`input-${index}`).value.trim()
            );

          const hasEmpty = inputs.some((name) => name === '');
          if (hasEmpty) {
            Swal.showValidationMessage('Por favor, preencha todos os campos.');
            return false;
          }

          return inputs;
        },
      });

      if (isConfirmed && Array.isArray(names)) {
        setCollectedNames(names); // Atualiza o estado com os nomes coletados
        localStorage.setItem('collectedNames', JSON.stringify(names)); // Salva no localStorage
        onAdd(names); // Envia os nomes ao pai
        
        // Processar pagamento automaticamente após confirmar os nomes
        if (onGenerateTickets) {
          // Exibir loading
          await Swal.fire({
            title: 'Aguarde...',
            text: 'Gerando pagamento...',
            timer: 5000,
            customClass: {
              popup: 'swal2-popup-custom',
              title: 'swal2-title-custom',
            },
            buttonsStyling: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          
          // Processar pagamento
          onGenerateTickets(names);
        }
      }
    }
    // handleGenerateTicketsClick()
  };

  // Função comentada - o pagamento agora é processado automaticamente após confirmar os nomes
  // const handleGenerateTicketsClick = async () => {
  //   const storedNames = localStorage.getItem('collectedNames');
  //   const names = storedNames ? JSON.parse(storedNames) : collectedNames;

  //   if (!names || names.length === 0) {
  //     alert('Por favor, adicione o nome completo.');
  //     return;
  //   }

  //   // Garante um atraso para sincronizar e exibir carregamento
  //   await Swal.fire({
  //     title: 'Aguarde...',
  //     text: 'Gerando pagamento...',
  //     timer: 5000,
  //     customClass: {
  //       popup: 'swal2-popup-custom',
  //       title: 'swal2-title-custom',
  //     },
  //     buttonsStyling: false,
  //     didOpen: () => {
  //       Swal.showLoading();
  //     },
  //   });

  //   // Após o carregamento, chama a função de geração de tickets
  //   if (onGenerateTickets) {
  //     onGenerateTickets(names);
  //   }
  // };

  return (
    <div className='add-name'>
      <h3>2° - Clique em comprar entradas e insira a quantidade de Ingressos que deseja adquirir. Após inserir os nomes, confirme para processar o pagamento. </h3>
      <button onClick={handlePurchaseClick}>Comprar Entradas</button>

      {/* Botão comentado - o pagamento agora é processado automaticamente após confirmar os nomes */}
      {/* <button onClick={handleGenerateTicketsClick}>Comprar Entradas</button> */}
    </div>
  );
}

export default AddName;

